import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@emotion/react";
import { STORAGE_URL } from "../../constants";
import { BackButton } from "../../components";
const NotFound = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const redirectHome = () => {
    navigate("/");
  };
  return (
    <Box>
      <Box sx={{ position: "absolute", top: "8%", left: "3%" }}>
        <BackButton />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: "--font-f_m",
              fontSize: { xl: "10vw", lg: "10vw", sm: "40px", xs: "40px" },
              fontWeight: "900",
              textAlign: "center",
              color: "#fff !important",
            }}
          >
            404
          </Typography>
          <Typography
            sx={{
              fontFamily: "var(--font-r_r)",
              fontSize: { xl: "35px", lg: "32px", sm: "28px", xs: "20px" },
              fontWeight: "700",
              textAlign: "center",
              textTransform: "capitalize",
              color: "#FFF !important",
            }}
          >
            Link is Broken
          </Typography>
          <Typography
            sx={{
              fontFamily: "var(--font-r_r)",
              fontSize: { xl: "25px", lg: "22px" },
              textAlign: "center",
              color: "#FFF !important",
            }}
          >
            Sorry, the page you were looking for was not found
          </Typography>
          <Button
            label={"Go Back"}
            isHeader
            originHeight
            sx={{
              marginRight: "8px",
              color: "#000 !important",
              backgroundColor: theme?.palette?.button?.default,
              mt: 2,
              borderColor: theme?.palette?.button?.default,
              fontWeight: "800",
              "&:hover": {
                color: "white !important",
              },
            }}
            onClick={redirectHome}
          />
        </Box>
      </Box>
    </Box>
  );
};
export default NotFound;
